import React, { useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  TextField,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  CircularProgress,
  Alert,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import presupuestosService from "../../../services/presupuestosService";
import DashboardLayout from "../../../layouts/DashboardLayout";

const Th = styled(TableCell)(({ theme }) => ({
  fontWeight: 700,
  fontSize: "0.78rem",
  padding: "6px 8px",
  whiteSpace: "nowrap",
  color: theme.palette.mode === "dark" ? theme.palette.common.white : theme.palette.primary.dark,
  backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaf1fb",
}));

const PRESUPUESTO_COLUMNS = [
  ["nombre", "Nombre"],
  ["concepto", "Concepto"],
  ["macrocuenta", "Macrocuenta"],
  ["Enero", "Enero"],
  ["Febrero", "Febrero"],
  ["Marzo", "Marzo"],
  ["Abril", "Abril"],
  ["Mayo", "Mayo"],
  ["Junio", "Junio"],
  ["Julio", "Julio"],
  ["Agosto", "Agosto"],
  ["Septiembre", "Septiembre"],
  ["Octubre", "Octubre"],
  ["Noviembre", "Noviembre"],
  ["Diciembre", "Diciembre"],
  ["cuenta", "Cuenta"],
  ["nro_contrato", "Nro Contrato"],
  ["moneda", "Moneda"],
  ["anio", "Año"],
  ["Observacion", "Observación"],
];

const CajaGeneralPage = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [year, setYear] = useState("");
  const [presupuestos, setPresupuestos] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!year) return;
    setLoading(true);
    try {
      const data = await presupuestosService.searchByYear(year);
      setPresupuestos(data);
    } catch (error) {
      console.error("Error al buscar presupuestos:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Box sx={{ p: 1 }}>
        <Typography variant="h5" gutterBottom>
          Caja General
        </Typography>
        <Tabs
          value={tabIndex}
          onChange={(e, newValue) => setTabIndex(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ mb: 3 }}
        >
          <Tab label="Egreso de Cheques" />
          <Tab label="Reportes Caja General" />
          <Tab label="Reportes de Balance" />
          <Tab label="Búsqueda" />
          <Tab label="Solicitudes" />
          <Tab label="Extracto Histórico" />
          <Tab label="Presupuestos" />
        </Tabs>

        {tabIndex === 0 && (
          <Typography>Egreso de Cheques</Typography>
        )}
        {tabIndex === 1 && (
          <Typography>Reportes Caja General </Typography>
        )}
        {tabIndex === 2 && (
          <Typography>Reportes de Balance </Typography>
        )}
        {tabIndex === 3 && <Typography>Búsqueda </Typography>}
        {tabIndex === 4 && <Typography>Solicitudes </Typography>}
        {tabIndex === 5 && (
          <Typography>Extracto Histórico </Typography>
        )}
        {tabIndex === 6 && (
          <Box>
            <Box
              component="form"
              onSubmit={handleSearch}
              sx={{ mb: 2, display: "flex", gap: 2 }}
            >
              <TextField
                label="Año"
                value={year}
                onChange={(e) => setYear(e.target.value)}
                size="small"
              />
              <Button type="submit" variant="contained">
                Buscar
              </Button>
            </Box>
            {loading && (
              <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                <CircularProgress size={22} />
              </Box>
            )}
            {!loading && presupuestos.length === 0 && (
              <Alert severity="info">Sin resultados.</Alert>
            )}
            {!loading && presupuestos.length > 0 && (
              <TableContainer sx={{ overflowX: "auto" }}>
                <Table size="small" sx={{ "& td": { py: 0.5, px: 1, fontSize: "0.78rem", whiteSpace: "nowrap" } }}>
                  <TableHead>
                    <TableRow>
                      {PRESUPUESTO_COLUMNS.map(([field, label]) => (
                        <Th key={field}>{label}</Th>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {presupuestos.map((row, i) => (
                      <TableRow key={row.id ?? i} hover>
                        {PRESUPUESTO_COLUMNS.map(([field]) => (
                          <TableCell key={field}>{row[field] ?? "-"}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>
        )}
      </Box>
    </DashboardLayout>
  );
};

export default CajaGeneralPage;